import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Somelys : ajout d'un produit complémentaire au panier.
 * - Cases « En complément » des fiches produit : ajoutées en même temps que le produit principal.
 * - Boutons « Ajouter » de la suggestion du tiroir panier.
 * Le panier (tiroir et page) est rafraîchi via l'événement standard CartLinesUpdateEvent.
 */

const root = () => window.Shopify?.routes?.root || '/';

/**
 * @param {string|number} variantId
 * @param {number} [quantity]
 * @param {number} [settleDelay] attente avant de relire le panier (laisse finir l'ajout du produit principal)
 */
export async function addExtraToCart(variantId, quantity = 1, settleDelay = 0) {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
    });
    if (settleDelay) await new Promise((resolve) => setTimeout(resolve, settleDelay));
    const cart = await (await fetch(`${root()}cart.js`)).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'somelys-extra', itemCount: quantity },
    });
    return response.ok;
  } catch (error) {
    deferred.reject(error);
    return false;
  }
}

if (!window.__somelysExtraAdd) {
  window.__somelysExtraAdd = true;

  // Choix de la variante : met à jour le prix affiché et la variante à ajouter
  document.addEventListener('change', (event) => {
    const select = event.target instanceof Element ? event.target.closest('[data-somelys-extra] select') : null;
    if (!(select instanceof HTMLSelectElement)) return;
    const box = select.closest('[data-somelys-extra]');
    const option = select.selectedOptions[0];
    const price = box?.querySelector('[data-somelys-price]');
    if (price && option) price.textContent = option.dataset.price || '';
    const checkbox = box?.querySelector('.toggle-cross-sell__checkbox');
    if (checkbox instanceof HTMLElement) checkbox.dataset.extraVariant = select.value;
  });

  // Bouton « Ajouter » (suggestion du tiroir panier)
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-somelys-add]') : null;
    if (!(button instanceof HTMLButtonElement)) return;
    event.preventDefault();
    const box = button.closest('[data-somelys-extra]');
    const select = box?.querySelector('select');
    const variantId = select instanceof HTMLSelectElement ? select.value : button.dataset.variantId;
    if (!variantId) return;
    button.disabled = true;
    addExtraToCart(variantId, 1).finally(() => {
      button.disabled = false;
    });
  });

  // Cases « En complément » cochées : ajoutées quand le produit principal est ajouté
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const scope = form.closest('.shopify-section') || document;
      scope.querySelectorAll('.toggle-cross-sell__checkbox:checked').forEach((box) => {
        if (box instanceof HTMLElement && box.dataset.extraVariant) addExtraToCart(box.dataset.extraVariant, 1, 700);
      });
    },
    true
  );
}
